<template>
	<v-layout row justify-center>
		<v-dialog
			:fullscreen="fullscreen"
			class="mobileFullscreen"
			v-model="showModal"
			lazy
			max-width="900px"
			:transition="utils.getSettings('animation')"
			@keydown.esc="showModal = false"
		>
			<v-card class="compact">
				<v-form
					v-model="valid"
					ref="reservationForm"
					lazy-validation
					:class="!showForm ? 'loading' : ''"
				>
					<v-tabs v-model="active" color="blue darken-3" dark>
						<v-tab v-for="tab in tabs" :key="tab" :href="'#' + tab" ripple>
							{{ tab }}
							<v-progress-circular
								:size="20"
								indeterminate
								color="white"
								v-if="priceLoading && tab === 'Kostenoverzicht'"
							></v-progress-circular>
						</v-tab>
						<v-tabs-slider color="yellow"></v-tabs-slider>
						<v-tabs-items
							:touchless="showMap === true || active === 'Unitplanner'"
						>
							<v-tab-item :key="'Gegevens'" :value="'Gegevens'">
								<v-card>
									<v-card-title>
										<h2>
											Gegevens #{{ selectedReservation.reservationNumber }}
										</h2>
										<small v-if="updateTime"
											>&nbsp;[Opgeslagen op: {{ updateTime }}]</small
										>
									</v-card-title>
									<v-card-text id="scroller touchOverflow">
										<v-container grid-list-md px-0>
											<v-layout wrap px-0>
												<v-flex md7 xs12 sm12 class="pt-0">
													<v-text-field
														label="Omschrijving"
														type="text"
														v-model="selectedReservation.rentDescription"
														required
														:rules="basicRules"
													></v-text-field>
												</v-flex>
												<v-flex
													md5
													xs12
													v-if="selectedReservation.isControllable === '1'"
												>
													<unit-control
														:showRefresh="!priceLoading"
														@refreshSensors="
															getReservationCost(selectedReservation.id)
														"
														:unitId="selectedReservation.unitId"
														:sensors="selectedReservation.sensors"
														:status="selectedReservation.status"
													></unit-control>
												</v-flex>
												<v-flex md7 xs12>
													<v-select
														v-bind:items="selectUnits"
														v-model="unitId"
														label="Selecteer auto"
														item-text="fullDescription"
														item-value="unitId"
														single-line
														class="dialogDropdown"
														menu-props="{'contentClass':'dialogDropdown','bottom':true}"
													></v-select>
												</v-flex>
												<v-flex md5 xs12>
													<v-checkbox
														label="Alleen beschikbare"
														v-model="onlyAvailableUnits"
													></v-checkbox>
												</v-flex>

												<v-flex xs8 sm5>
													<v-dialog
														ref="menu"
														:close-on-content-click="false"
														v-model="menu"
														transition="scale-transition"
														offset-y
														full-width
														width="290px"
														:return-value.sync="selectedReservation.startDate"
													>
														<div class="blue darken-2 dark pl-3 pt-2">
															<h3>Startdatum</h3>
														</div>
														<v-text-field
															slot="activator"
															label="Startdatum"
															v-model="fullStartDate"
															prepend-icon="event"
															readonly
														></v-text-field>
														<v-date-picker
															v-model="selectedReservation.startDate"
															locale="nl"
															@change="
																$refs.menu.save(selectedReservation.startDate);
																checkWhenModified();
															"
															scrollable
														>
															<v-spacer></v-spacer>
															<v-btn flat color="primary" @click="menu = false"
																>Annuleren</v-btn
															>
														</v-date-picker>
													</v-dialog>
												</v-flex>
												<v-flex xs3 sm4 md4>
													<v-text-field
														label="Tijd"
														v-model="selectedReservation.startTime"
														@focus="startTimeFocus = true"
														@blur="startTimeFocus = false"
														@change="checkWhenModified()"
														type="time"
														suffix
													></v-text-field>
												</v-flex>
												<v-flex xs8 sm5>
													<v-dialog
														ref="menu2"
														:close-on-content-click="false"
														v-model="menu2"
														transition="scale-transition"
														offset-y
														full-width
														width="290px"
														:return-value.sync="selectedReservation.endDate"
													>
														<div class="blue darken-2 dark pl-3 pt-2">
															<h3>Einddatum</h3>
														</div>
														<v-text-field
															slot="activator"
															label="Einddatum"
															v-model="fullEndDate"
															prepend-icon="event"
															readonly
														></v-text-field>
														<v-date-picker
															v-model="selectedReservation.endDate"
															locale="nl"
															@change="
																$refs.menu2.save(selectedReservation.endDate);
																checkWhenModified();
															"
															scrollable
														>
															<v-spacer></v-spacer>
															<v-btn flat color="primary" @click="menu2 = false"
																>Annuleren</v-btn
															>
														</v-date-picker>
													</v-dialog>
												</v-flex>
												<v-flex xs3 sm4 md4>
													<v-text-field
														label="Tijd"
														v-model="selectedReservation.endTime"
														@focus="endTimeFocus = true"
														@blur="endTimeFocus = false"
														@change="checkWhenModified()"
														type="time"
														suffix
													></v-text-field>
												</v-flex>
												<v-flex xs1 sm1 md1>
													<v-checkbox
														label="Max eindtijd"
														v-model="selectedReservation.hasMaxTime"
														@change="checkWhenModified()"
														class="maxEnd"
													></v-checkbox>
												</v-flex>
												<v-flex xs4>
													<v-text-field
														label="Kosten"
														type="text"
														v-model="selectedReservation.cost"
														readonly
													></v-text-field>
												</v-flex>
												<v-flex xs4>
													<v-text-field
														label="Afgelegde afstand"
														type="text"
														v-model="selectedReservation.mileage"
														readonly
													></v-text-field>
												</v-flex>
												<v-flex xs4>
													<v-text-field
														label="Pincode tankpas"
														type="text"
														v-model="selectedReservation.fuelCardPin"
														readonly
													></v-text-field>
												</v-flex>
												<v-flex xs4>
													<v-text-field
														label="Km prijs"
														type="number"
														min="0"
														step="0.01"
														v-model="selectedReservation.kmPrice"
														@change="checkWhenModified()"
													></v-text-field>
												</v-flex>
												<v-flex xs4>
													<v-text-field
														label="Korting"
														type="number"
														min="0"
														step="0.01"
														v-model="selectedReservation.discount"
														@change="checkWhenModified()"
													></v-text-field>
												</v-flex>
												<v-flex xs4>
													<v-text-field
														label="Km vrij"
														type="number"
														readonly
														v-model="selectedReservation.costData.totalKmFree"
													></v-text-field>
												</v-flex>
												<v-flex xs9 md10>
													<v-text-field
														label="Gebruiker"
														v-model="fullName"
														readonly
													></v-text-field>
												</v-flex>
												<v-flex xs3 md2>
													<v-btn
														color="primary"
														flat
														@click="editUser = !editUser"
														>Wijzig</v-btn
													>
												</v-flex>
												<v-flex v-if="editUser" xs12>
													<v-autocomplete
														autofocus
														label="Zoek gebruiker"
														autocomplete="false"
														:loading="userLoading"
														item-text="Name"
														item-value="user_id"
														placeholder="Voornaam, achternaam, e-mail"
														:no-data-text="search ? 'Geen resultaten' : ''"
														chips
														:items="items"
														:search-input.sync="search"
														v-model="select"
													></v-autocomplete>
												</v-flex>
												<v-flex xs6>
													<v-text-field
														label="Telefoonummer"
														type="text"
														v-model="selectedReservation.phoneno"
														readonly
													></v-text-field>
												</v-flex>
												<v-flex xs6>
													<v-text-field
														label="Woonplaats"
														type="text"
														v-model="selectedReservation.city"
														readonly
													></v-text-field>
												</v-flex>
											</v-layout>
										</v-container>
										<small>* verplichte velden</small>
									</v-card-text>
								</v-card>
							</v-tab-item>

							<v-tab-item :key="'Kostenoverzicht'" :value="'Kostenoverzicht'">
								<v-card>
									<v-card-title>
										<h2>Kostenoverzicht #{{ selectedReservation.reservationNumber }}</h2>
									</v-card-title>
									<v-card-text>
										<v-container grid-list-md px-1>
											<v-layout wrap>
												<reservation-cost-details
													v-if="selectedReservation.id"
													:reservation="selectedReservation"
													:editable="true"
												/>
												<v-flex xs6>
													<v-btn
														color="darken-1"
														v-if="!priceLoading"
														flat
														@click.native="
															$refs.viewInvoice.showDialog(
																selectedReservation,
																'view',
																true
															)
														"
													>
														<v-icon>picture_as_pdf</v-icon>Toon proforma
													</v-btn>
													<v-progress-circular
														:size="20"
														indeterminate
														color="black"
														v-if="priceLoading"
													></v-progress-circular>
												</v-flex>
												<v-flex xs6>
													<v-btn
														color="darken-1"
														flat
														@click.native="
															$refs.viewInvoice.showDialog(
																selectedReservation,
																'send',
																true
															)
														"
														v-if="!priceLoading"
													>
														<v-icon>mail</v-icon>Mail proforma
													</v-btn>
													<v-progress-circular
														:size="20"
														indeterminate
														color="black"
														v-if="priceLoading"
													></v-progress-circular>
												</v-flex>
											</v-layout>
										</v-container>
									</v-card-text>
								</v-card>
							</v-tab-item>

							<v-tab-item :key="'Aanvullend'" :value="'Aanvullend'">
								<v-card>
									<v-card-title>
										<h2>Aanvullende gegevens</h2>
									</v-card-title>
									<v-card-text>
										<v-container grid-list-md pa-0>
											<v-layout wrap mt-3>
												<v-flex xs12>
													<fuel-slider
														:fuelLevel="selectedReservation.fuelLevel"
														@setFuelLevel="updateFuelLevel($event)"
													></fuel-slider>
												</v-flex>
												<v-flex xs4>
													<v-text-field
														label="Kmstand start"
														type="number"
														v-model="selectedReservation.kmStart"
													></v-text-field>
												</v-flex>
												<v-flex xs4>
													<v-text-field
														label="Kmstand eind"
														type="number"
														v-model="selectedReservation.kmEnd"
													></v-text-field>
												</v-flex>
												<v-flex xs4>
													<v-text-field
														label="Km gereden"
														type="number"
														readonly
														v-model="kmDifference"
													></v-text-field>
												</v-flex>
												<v-textarea
													name="remarks"
													label="Opmerkingen. Vul hier in"
													value
													v-model="selectedReservation.remarks"
												></v-textarea>
											</v-layout>
										</v-container>
									</v-card-text>
								</v-card>
							</v-tab-item>

							<v-tab-item :key="'Kaart'" :value="'Kaart'">
								<v-card style="min-height: 45vh">
									<v-card-title @click="showMap = false">
										<h2>Locatie</h2>
									</v-card-title>
									<v-card-text>
										<v-container grid-list-md pa-1>
											<v-layout wrap>
												<v-img
													:src="mapsUrl"
													height="100%"
													@click="showMap = true"
													v-if="mapsUrl"
												>
													<gmap-map
														:center="{
															lat: selectedReservation.lat,
															lng: selectedReservation.lng
														}"
														v-if="
															showMap &&
																selectedReservation.wialonUnitId !== '0'
														"
														:zoom="zoomLevel"
														:options="{ gestureHandling: 'greedy' }"
														map-type-id="terrain"
														style="width: 100%; height: 100%"
													>
														<gmap-marker
															:key="index"
															v-for="(m, index) in markers"
															:position="m.position"
															:clickable="true"
															@click="center = m.position"
														></gmap-marker>
													</gmap-map>
												</v-img>

												<p v-if="selectedReservation.wialonUnitId === '0'">
													Niet beschikbaar
												</p>
											</v-layout>
										</v-container>
									</v-card-text>
								</v-card>
							</v-tab-item>

							<v-tab-item :key="'Klantgegevens'" :value="'Klantgegevens'">
								<v-card>
									<v-card-text class="py-0">
										<customer-card :user="selectedReservation"></customer-card>
										<temp-customer
											@setUseTempForInvoice="
												selectedReservation.useTempForInvoice = $event
											"
											v-if="selectedReservation.tempCustomer"
											:optional="true"
											:user="selectedReservation.tempCustomer"
											:useTempForInvoice="selectedReservation.useTempForInvoice"
											:showInvoiceOption="true"
										></temp-customer>
									</v-card-text>
								</v-card>
							</v-tab-item>

							<v-tab-item :key="'Opties'" :value="'Opties'">
								<v-card>
									<v-card-title>
										<h2>Opties</h2>
									</v-card-title>
									<v-card-text>
										<v-container grid-list-md px-1>
											<v-layout wrap>
												<v-flex xs12>
													<v-btn
														color="red"
														flat
														@click="confirm['delete'] = true"
														>Verwijderen</v-btn
													>
													<v-btn @click="sendConfirmation()"
														>Stuur bevestiging</v-btn
													>
													<v-btn @click="showAgreement()"
														>Download overeenkomst</v-btn
													>
												</v-flex>
												<v-flex
													xs4
													class="ml-4"
													v-if="userType === 'with-site'"
												>
													<v-text-field
														label="Bedrag"
														type="number"
														v-model="prepaidAmount"
														min="2"
														@change="checkAmount($event)"
													></v-text-field>
												</v-flex>
												<v-flex xs6 v-if="userType === 'with-site'">
													<v-btn @click="gotoPrepaidShare()"
														>Deel betaallink</v-btn
													>
												</v-flex>
												<v-flex xs4 class="ml-4">
													<v-text-field
														label="Handmatige betaling toevoegen"
														type="number"
														v-model="manualPaidAmount"
													></v-text-field>
												</v-flex>
												<v-flex xs6>
													<v-btn @click="savePaidAmount()">Opslaan</v-btn>
												</v-flex>
												<v-flex xs6>
													<v-btn @click="copyReservation()"
														>Kopieer naar nieuwe reservering</v-btn
													>
												</v-flex>
											</v-layout>
										</v-container>
									</v-card-text>
								</v-card>
							</v-tab-item>

							<v-tab-item :key="'Unitplanner'" :value="'Unitplanner'">
								<v-card style="min-height: 45vh">
									<v-card-title>
										<h2>Unitplanner</h2>
									</v-card-title>
									<v-card-text>
										<v-container grid-list-md pa-1>
											<v-layout wrap>
												<planner
													v-if="active === 'Unitplanner'"
													:selectedUnit="selectedReservation.unitId"
												></planner>
											</v-layout>
										</v-container>
									</v-card-text>
								</v-card>
							</v-tab-item>

							<v-layout row wrap>
								<v-flex xs3 md7>
									<v-btn color="darken-1" flat @click.native="closeModal()"
										>Sluiten</v-btn
									>
								</v-flex>
								<v-flex xs9 md5 text-xs-right>
									<v-btn
										color="black"
										style="float: left"
										dark
										@click="confirm['end'] = true"
										>Beëindigen</v-btn
									>
									<v-btn
										color="primary darken-1"
										v-if="selectedReservation.closed === '0'"
										:disabled="
											!selectedReservation.costData.prices || saveDisabled
										"
										@click.native="updateReservation()"
										>Opslaan</v-btn
									>
								</v-flex>
							</v-layout>
						</v-tabs-items>
					</v-tabs>
				</v-form>
			</v-card>
		</v-dialog>
		<v-dialog v-model="confirm['delete'] || confirm['end']" max-width="290">
			<v-card>
				<v-card-title class="headline">Weet u het zeker?</v-card-title>
				<v-card-text v-if="confirm['delete']"
					>Klik op bevestigen om de reservering te verwijderen.</v-card-text
				>
				<v-card-text v-if="confirm['end']">
					<v-checkbox
						label="Stuur factuur mee"
						v-model="sendInvoice"
					></v-checkbox
					>Klik op bevestigen om de reservering te beëindigen.
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="gray darken-1"
						flat="flat"
						@click.native="
							confirm['delete'] = false;
							confirm['end'] = false;
						"
						>Annuleren</v-btn
					>
					<v-btn
						color="primary"
						@click.native="
							confirm['delete'] ? deleteReservation() : endReservation()
						"
						>Bevestigen</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-snackbar :top="true" :timeout="2000" v-model="showMessage">
			{{ msg }}
			<v-btn dark flat @click.native="showMessage = false">Sluiten</v-btn>
		</v-snackbar>
		<view-invoice ref="viewInvoice" :customDate="true"></view-invoice>
	</v-layout>
</template>
<script>
import * as utils from '@/utils/utils';
import moment from 'moment';
import { _ } from 'vue-underscore';
import ReservationCostDetails from '@/components/Reservations/ReservationCostDetails';
import UnitControl from '@/components/Units/UnitControl';
import CustomerCard from '@/components/subcomponents/CustomerCard';
import TempCustomer from '@/components/subcomponents/TempCustomer';
import FuelSlider from '@/components/subcomponents/FuelSlider';
import SelectPeriod from '@/components/Reservations/SelectPeriod';
import ViewInvoice from '@/components/Reservations/ViewInvoice';

export default {
	name: 'ReservationsModal',
	components: {
		ReservationCostDetails,
		UnitControl,
		CustomerCard,
		TempCustomer,
		FuelSlider,
		SelectPeriod,
		ViewInvoice
	},
	created: function() {
		if (window.innerHeight < 750 && window.innerWidth < 750) {
			this.fullscreen = true;
		}
	},
	mounted() {
		var self = this;
		this.allUnits = this.units;

		setTimeout(function() {
			self.active = 'Gegevens';
		}, 0);

		this.userType = localStorage.getItem('t');
	},
	data() {
		return {
			tabs: [
				'Gegevens',
				'Kostenoverzicht',
				'Aanvullend',
				'Kaart',
				'Klantgegevens',
				'Opties',
				'Unitplanner'
			],
			active: null,
			valid: false,
			onlyAvailableUnits: false,
			unitId: '',
			unitList: [],
			allUnits: [],
			showMessage: false,
			msg: '',
			menu: false,
			menu2: false,
			dialog: false,
			showForm: false,
			loading: false,
			priceLoading: false,
			userLoading: false,
			sendInvoice: true,
			saveDisabled: false,
			confirm: {
				end: false,
				delete: false
			},
			unitDate: {},
			selectedReservation: {
				startTime: '00:01',
				endTime: '23:59',
				fuelLevel: [],
				costData: {
					additionalItems: []
				},
				sensors: {},
				status: {},
				showPricesModal: false
			},
			emptyReservation: {
				startTime: '00:01',
				endTime: '23:59',
				costData: {
					additionalItems: []
				},
				fuelLevel: [],
				sensors: {},
				status: {},
				showPricesModal: false
			},
			basicRules: [v => !!v || 'Verplicht veld'],
			search: null,
			searchUsers: [],
			editUser: false,
			select: '',
			showMap: false,
			startTimeFocus: false,
			endTimeFocus: false,
			items: [],
			markers: [],
			utils: utils,
			showModal: false,
			id: 0,
			updateTime: '',
			zoomLevel: 7,
			fullscreen: false,
			useTempForInvoice: false,
			prepaidAmount: 0,
			manualPaidAmount: 0,
			mapsUrl: '',
			userType: 'default'
		};
	},
	props: ['user', 'edit', 'units'],
	computed: {
		fullName() {
			return this.selectedReservation.firstname
				? this.selectedReservation.firstname +
						' ' +
						this.selectedReservation.lastname +
						' (' +
						this.selectedReservation.username +
						')'
				: '';
		},
		fullStartDate() {
			return this.utils.getFullDate(this.selectedReservation.startDate);
		},
		fullEndDate() {
			return this.utils.getFullDate(this.selectedReservation.endDate);
		},
		kmDifference() {
			return (
				parseInt(this.selectedReservation.kmEnd) -
				parseInt(this.selectedReservation.kmStart)
			);
		},
		selectUnits() {
			if (!this.unitList.length) {
				return this.units;
			} else {
				return this.unitList;
			}
		},
		prepaidLink() {
			return encodeURI(
				'whatsapp://send?text=U kunt een aanbetaling doen via deze link: ' +
					basePath.replace('manager/index.php/', '') +
					'account/prePayment/' +
					this.selectedReservation.id
			);
		}
	},
	watch: {
		onlyAvailableUnits(checked) {
			if (checked) {
				this.getAvailableUnits();
			} else {
				this.unitList = this.allUnits;
			}
		},
		showModal: function(value) {
			if (!value) {
				this.showMap = false;
			}
			//this.setModalScroll(!value);
		},
		'selectedReservation.startTime'() {
			if (
				this.startTimeFocus &&
				moment(this.selectedReservation.startDate, 'YYYY-MM-DD').isSame(
					moment(this.selectedReservation.endDate),
					'day'
				)
			) {
				var format = 'hh:mm';
				var startTime = moment(this.selectedReservation.startTime, format);
				var endTime = moment(this.selectedReservation.endTime, format);
				if (startTime.isAfter(endTime)) {
					//  this.selectedReservation.startTime = endTime.add(-1, 'hours').format("HH:mm");
				}
			}
		},
		'selectedReservation.endTime'() {
			if (
				this.endTimeFocus &&
				moment(this.selectedReservation.startDate, 'YYYY-MM-DD').isSame(
					moment(this.selectedReservation.endDate),
					'day'
				)
			) {
				var format = 'hh:mm';
				var startTime = moment(this.selectedReservation.startTime, format);
				var endTime = moment(this.selectedReservation.endTime, format);
				if (endTime.isBefore(startTime)) {
					// this.selectedReservation.endTime = startTime.add(1, 'hours').format("HH:mm");
				}
			}
		},
		unitId: function(val, oldVal) {
			if (val && oldVal) {
				var selectedUnit = _.where(this.selectUnits, { unitId: val });
				if (selectedUnit && selectedUnit.length) {
					this.selectedReservation.freeMileage = selectedUnit[0].freeMileage;
					this.selectedReservation.rentDescription =
						this.selectedReservation.rentDescription &&
						this.selectedReservation.rentDescription.indexOf('Verhuur') < 0
							? this.selectedReservation.rentDescription
							: 'Verhuur ' +
							  selectedUnit[0].name +
							  ' ' +
							  selectedUnit[0].license;
					this.selectedReservation.unitId = val;
					this.selectedReservation.costData.prices = [];
				}
			}
		},
		search(val) {
			val && this.querySelections(val);
		},
		select(newVal) {
			var selectedUser = _.findWhere(this.items, { user_id: newVal });
			this.selectedReservation.username = selectedUser.username;
			this.selectedReservation.phoneno = selectedUser.phoneno;
			this.selectedReservation.city = selectedUser.city;
			this.selectedReservation.license = selectedUser.license;
			this.selectedReservation.firstname = selectedUser.firstname;
			this.selectedReservation.lastname = selectedUser.lastname;
			this.selectedReservation.birthdate = selectedUser.birthdate;
			this.selectedReservation.street = selectedUser.street;
			this.selectedReservation.streetno = selectedUser.streetno;
			this.selectedReservation.zip = selectedUser.zip;
		},
		active(val) {
			if (val !== 'Kaart') {
				this.showMap = false;
			}
		}
	},
	methods: {
		// Update reservations cost when changing dates
		checkWhenModified() {
			this.checkReservationDates();
			this.getUpdateReservationCost();
		},
		showReservation(id, toFirstTab) {
			var self = this;
			this.id = id;
			this.showModal = true;

			setTimeout(function() {
				self.getReservationData(id, true);
			}, 100);
		},
		// Get the reservation data
		getReservationData(id, toFirstTab) {
			if (this.showModal) {
				var self = this;
				if (toFirstTab) {
					this.active = 'Gegevens';
				}
				self.loading = true;
				self.showForm = false;
				self.updateTime = '';
				// Get data
				utils
					.getData(basePath + 'api/reservations/reservationDetails/' + id)
					.then(function(json) {
						self.selectedReservation = json.data;
						self.showForm = true;
						var selectedUnit = _.where(self.selectUnits, {
							unitId: self.selectedReservation.unitId
						});
						self.unitId = self.selectedReservation.unitId;
						self.selectedReservation.rentDescription = self.selectedReservation
							.rentDescription
							? self.selectedReservation.rentDescription
							: 'Verhuur ' +
							  selectedUnit[0].name +
							  ' ' +
							  selectedUnit[0].license;
						self.selectedReservation.sensors = {};
						self.selectedReservation.setCustomDistance =
							self.selectedReservation.setCustomDistance === '1';
						var startDate = moment(self.selectedReservation.startDate).format(
							'YYYY-MM-DD'
						);
						var endDate = moment(self.selectedReservation.endDate).format(
							'YYYY-MM-DD'
						);
						if (moment(startDate).isValid() && moment(endDate).isValid()) {
							self.selectedReservation.startTime = moment(
								self.selectedReservation.startDate
							).format('HH:mm');
							self.selectedReservation.startDate = startDate;
							self.selectedReservation.endTime = moment(
								self.selectedReservation.endDate
							).format('HH:mm');
							self.selectedReservation.endDate = endDate;
						} else {
							self.selectedReservation.startTime = '00:00';
							self.selectedReservation.startDate = moment(new Date()).format(
								'YYYY-MM-DD'
							);
							self.selectedReservation.endTime = '18:00';
							self.selectedReservation.endDate = moment(new Date()).format(
								'YYYY-MM-DD'
							);
						}

						if (!self.selectedReservation.tempCustomer) {
							self.selectedReservation.tempCustomer = {};
						}
						self.selectedReservation.hasMaxTime =
							parseInt(self.selectedReservation.hasMaxTime) === 0
								? false
								: true;
						self.loading = true;
						self.getReservationCost(id);
					});
			}
		},
		getReservationCost(id) {
			var self = this;
			self.priceLoading = true;
			// Get cost and position
			utils
				.getData(basePath + 'api/reservations/reservationCost/' + id)
				.then(function(response) {
					self.priceLoading = false;
					if (response && response.data) {
						if (response.data.unitData && response.data.unitData.length) {
							self.selectedReservation.lat = response.data.unitData[0].pos.y;
							self.selectedReservation.lng = response.data.unitData[0].pos.x;
							self.selectedReservation.mileage = response.data.mileage;
							self.selectedReservation.status =
								response.data.unitData[0].status;
							if (response.data.mileage < 10) {
								self.zoomLevel = 14;
							} else {
								self.zoomLevel = 7;
							}
						}

						self.selectedReservation.cost = response.data.cost.total;
						self.selectedReservation.costData = response.data.cost;
						self.selectedReservation.sensors = response.data.sensors;
						self.selectedReservation.showPricesModal = false;
						self.selectedReservation.wialonUnitId =
							response.data.unitData[0].wialonUnitId;

						if (self.selectedReservation.wialonUnitId === '0') {
							self.selectedReservation.setCustomDistance = true;
						}

						self.selectedReservation.totalWithoutDiscount =
							self.selectedReservation.costData.totalDecimal -
							self.selectedReservation.costData.discount;
						self.selectedReservation.totalWithoutMileageCost =
							self.selectedReservation.totalWithoutDiscount -
							self.selectedReservation.costData.mileage *
								self.selectedReservation.kmPrice;

						self.markers[0] = {
							position: {
								lat: self.selectedReservation.lat,
								lng: self.selectedReservation.lng
							}
						};

						// Set maps
						self.setMapsUrl();

						// Prepaid amount
						if (!self.selectedReservation.costData.totalDecimal) {
							self.prepaidAmount = 0;
						}
						self.prepaidAmount = (
							self.selectedReservation.costData.totalDecimal -
							self.selectedReservation.amountPaid
						).toFixed(2);
					}
				});
		},
		// Show precalculated cost when changing values
		getUpdateReservationCost() {
			var self = this;
			if (this.selectedReservation.unitId) {
				this.priceLoading = true;
				var data = _.clone(this.selectedReservation);
				data.costData = {};
				data.startDate = moment(
					data.startDate + ':' + data.startTime,
					'YYYY-MM-DD HH:mm'
				).format();
				data.endDate = moment(
					data.endDate + ':' + data.endTime,
					'YYYY-MM-DD HH:mm'
				).format();
				utils
					.setData(basePath + 'api/reservations/newReservationCost/', data)
					.then(function(response) {
						self.priceLoading = false;
						if (response && response.data) {
							self.selectedReservation.costData = response.data;
							self.selectedReservation.cost = response.data.total;
						}
						self.loading = false;
					});
			}
		},
		closeModal() {
			var self = this;
			this.showModal = false;

			setTimeout(function() {
				self.showForm = false;
			}, 300);
		},
		querySelections(v) {
			var self = this;
			this.userLoading = true;
			var data = {
				query: v
			};
			utils
				.setData(basePath + 'api/users/searchUsers/', data)
				.then(function(response) {
					if (response && response.data) {
						self.items = response.data;
						self.searchUsersData = response.data;
					}
					self.userLoading = false;
				});
		},
		updateReservation() {
			var self = this;
			// self.showLoader(true);
			if (this.$refs.reservationForm.validate()) {
				var data = {
					startDate: moment(
						self.selectedReservation.startDate +
							':' +
							self.selectedReservation.startTime,
						'YYYY-MM-DD HH:mm'
					).format(),
					endDate: moment(
						self.selectedReservation.endDate +
							':' +
							self.selectedReservation.endTime,
						'YYYY-MM-DD HH:mm'
					).format(),
					user_id: this.select ? this.select : self.selectedReservation.user_id,
					unitId: self.selectedReservation.unitId,
					kmPrice: self.selectedReservation.kmPrice,
					discount: self.selectedReservation.discount,
					freeMileage: self.selectedReservation.freeMileage,
					rentDescription: self.selectedReservation.rentDescription,
					prices: self.selectedReservation.costData.prices,
					vat: self.selectedReservation.vat,
					remarks: self.selectedReservation.remarks,
					additionalItems: self.selectedReservation.costData.additionalItems,
					tempCustomer: self.selectedReservation.tempCustomer,
					tempCustomerId: self.selectedReservation.tempCustomerId,
					useTempCustomer: self.selectedReservation.tempCustomer.useTempCustomer
						? self.selectedReservation.tempCustomer.useTempCustomer
						: false,
					useTempForInvoice: self.selectedReservation.useTempForInvoice,
					setCustomDistance: self.selectedReservation.setCustomDistance,
					kmStart: self.selectedReservation.kmStart,
					kmEnd: self.selectedReservation.kmEnd,
					hasMaxTime: self.selectedReservation.hasMaxTime,
					fuelStart:
						self.selectedReservation.fuelLevel &&
						self.selectedReservation.fuelLevel.length
							? self.selectedReservation.fuelLevel[0]
							: 0,
					fuelEnd:
						self.selectedReservation.fuelLevel &&
						self.selectedReservation.fuelLevel.length
							? self.selectedReservation.fuelLevel[1]
							: 0,
					customDistance: self.selectedReservation.setCustomDistance
						? self.selectedReservation.costData.mileage
						: 0
				};

				self.loading = true;

				utils
					.setData(
						basePath + 'api/reservations/updateReservationDetails/' + this.id,
						data
					)
					.then(function(json) {
						self.updateTime = new Date().toLocaleString();
						self.loading = false;
						self.showLoader(false);

						if (
							self.selectedReservation.tempCustomer.useTempCustomer === false
						) {
							self.selectedReservation.tempCustomer = {};
						} else {
							self.selectedReservation.tempCustomerId = json.tempCustomerId;
						}

						window.emitter.$emit('showToastMessage', {
							msg: 'Reservering opgeslagen'
						});
						setTimeout(function() {
							self.updateModel('update', self.id);
							self.getReservationCost(self.id);
						}, 100);
					});
			}
		},
		deleteReservation() {
			var self = this;
			self.loading = true;
			utils
				.getData(basePath + 'api/reservations/deleteReservation/' + this.id)
				.then(function(json) {
					self.showModal = false;
					self.updateModel('update', self.id);
					window.emitter.$emit('showToastMessage', {
						msg: 'Reservering verwijderd'
					});
					self.loading = false;
					self.selectedReservation = self.emptyReservation;
				});
			this.confirm.delete = false;
		},
		endReservation() {
			var self = this;
			self.loading = true;
			self.showLoader(true);

			var data = {
				sendInvoice: self.sendInvoice
			};

			utils
				.setData(basePath + 'api/reservations/endReservation/' + this.id, data)
				.then(function(json) {
					if (json.data.result == '1') {
						window.emitter.$emit('showToastMessage', {
							msg: 'Reservering beëindigd'
						});
						self.updateModel('remove', self.id);
						self.loading = false;
						self.showLoader(false);
						self.showModal = false;
					} else {
						window.emitter.$emit('showToastMessage', {
							msg: 'Error',
							type: 'error'
						});
					}
				});
			this.confirm.end = false;
		},
		updateModel(action, reservationId) {
			window.emitter.$emit('updateReservations', {
				action: action,
				id: reservationId
			});
			this.$emit('update');
		},
		searchUser(e) {
			// if (e.code == 'Backspace') {
			//   if (this.select) {
			//     this.select = null;
			//     this.search = '';
			//   }
			// }
		},
		newUser() {
			this.$emit('newUser');
		},
		showPreInvoice() {
			var self = this;
			utils
				.getData(
					basePath +
						'api/reservations/getPreInvoice/' +
						this.selectedReservation.id
				)
				.then(function(json) {
					window.location.href =
						basePath +
						'api/downloader/downloadInvoice/' +
						json.data +
						'/' +
						self.selectedReservation.id;
				});
		},
		sendPreInvoice() {
			var self = this;
			this.priceLoading = true;
			utils
				.getData(
					basePath +
						'api/reservations/sendPreInvoice/' +
						this.selectedReservation.id
				)
				.then(function(json) {
					self.priceLoading = false;
					if (json && json.data) {
						window.emitter.$emit('showToastMessage', {
							msg: 'Factuur verzonden.'
						});
					}
				});
		},
		checkReservationDates() {
			if (
				!moment(
					this.selectedReservation.startDate +
						' ' +
						this.selectedReservation.startTime,
					'YYYY-MM-DD HH:mm'
				).isBefore(
					moment(
						this.selectedReservation.endDate +
							' ' +
							this.selectedReservation.endTime,
						'YYYY-MM-DD HH:mm'
					)
				)
			) {
				window.emitter.$emit('showToastMessage', {
					msg: 'Startdatum ligt na de einddatum',
					type: 'error'
				});
				this.saveDisabled = true;
			} else {
				this.saveDisabled = false;
			}
		},
		allowedStartDates(val) {
			return (
				moment(val, 'YYYY-MM-DD').isBefore(
					moment(this.selectedReservation.endDate)
				) ||
				moment(val, 'YYYY-MM-DD').isSame(
					moment(this.selectedReservation.endDate),
					'day'
				)
			);
		},
		allowedEndDates(val) {
			return (
				moment(val, 'YYYY-MM-DD').isAfter(
					moment(this.selectedReservation.startDate)
				) ||
				moment(val, 'YYYY-MM-DD').isSame(
					moment(this.selectedReservation.startDate),
					'day'
				)
			);
		},
		getAvailableUnits() {
			var self = this;
			utils
				.setData(
					basePath + 'api/rentunits/getUnitsBySchedule/',
					this.selectedReservation
				)
				.then(function(json) {
					if (json && json.data) {
						self.unitList = json.data;
					}
				});
		},
		showLoader(enable) {
			window.emitter.$emit('showLoading', {
				enable: enable,
				msg: 'Gegevens ophalen'
			});
		},
		setModalScroll(enable) {
			let el = document.getElementById('reservationsContainer');
			if (el) {
				if (!enable) {
					el.classList.add('inActiveScroll');
				} else {
					el.classList.remove('inActiveScroll');
				}
			}
		},
		updateFuelLevel(value) {
			this.selectedReservation.fuelLevel = value;
		},
		sendConfirmation() {
			var self = this;
			utils
				.getData(
					basePath +
						'api/reservations/sendConfirmation/' +
						this.selectedReservation.id
				)
				.then(function(json) {
					window.emitter.$emit('showToastMessage', {
						msg: 'Bevestiging verzonden.'
					});
				});
		},
		showAgreement() {
			var self = this;
			utils
				.getData(
					basePath +
						'api/users/getAgreement/' +
						this.selectedReservation.user_id +
						'/' +
						this.selectedReservation.id
				)
				.then(function(json) {
					window.location.href =
						basePath +
						'api/downloader/downloadAgreement/' +
						json.data +
						'/' +
						self.selectedReservation.id;
				});
		},
		gotoPrepaidShare() {
			var self = this;
			let data = {
				amount: this.prepaidAmount,
				rentId: this.selectedReservation.id
			};
			utils
				.setData(basePath + 'api/users/setPrepaidAmount/', data)
				.then(function(response) {
					window.location.href = self.prepaidLink + '/' + response.data;
				});
		},
		savePaidAmount() {
			var self = this;
			let data = {
				amount: this.manualPaidAmount,
				rentId: this.selectedReservation.id
			};
			utils
				.setData(basePath + 'api/users/setPaidAmount/', data)
				.then(function(response) {
					self.manualPaidAmount = 0;
					window.emitter.$emit('showToastMessage', {
						msg: 'Betaling opgeslagen'
					});
					self.getReservationData(self.id, false);
				});
		},
		checkAmount(data) {
			if (parseInt(data) < 2) {
				this.prepaidAmount = 2;
			}
		},
		setPeriod(data) {
			if (data.endTime) {
				this.selectedReservation.endTime = data.endTime;
			}
			if (data.endDate) {
				this.selectedReservation.endDate = data.endDate;
			}
		},
		copyReservation() {
			this.$emit('copyReservation', this.selectedReservation);
			this.showModal = false;
		},
		setMapsUrl() {
			var self = this;
			if (self.selectedReservation.lat) {
				var pos =
					self.selectedReservation.lat + ',' + self.selectedReservation.lng;
				var color = 'red';
				var key = 'AIzaSyCgaCVWpKectL7lCRTC7oriHlBx7I_bV3w';
				var url =
					'//maps.googleapis.com/maps/api/staticmap?center=' +
					pos +
					'&zoom=6&size=400x400&markers=color:' +
					color +
					'%7C' +
					pos +
					'&key=' +
					key;
				self.mapsUrl = url;
			} else {
				self.mapsUrl = '';
			}
		}
	}
};
</script>




// WEBPACK FOOTER //
// src/components/Reservations/ReservationsModal.vue